import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import KeyValueDTO from '../models/generic/KeyValueDTO';

export class RoleApiController {
    // get: Role/GetAllRoles
    public RouteGetAllRoles = () => `Role/GetAllRoles`;
    public getAllRoles(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<string, number>[]>> {
        let url = this.RouteGetAllRoles();
        return HttpApi.RestRequest<any, KeyValueDTO<string, number>[]>(null, 'get', url, requestOptions);
    }
}
var service = new RoleApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/RoleApiController.ts